import loading from '../helpers/loading'
import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    wallet: {}
  },
  mutations: {
    ...loading.mutations,
    updateWallet: (state, { wallet }) => (state.wallet = wallet)
  },
  getters: {
    ...loading.getters,
    wallet: state => ({ ...state.wallet })
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/wallets/index.js